export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path === from.path) return;
  const disclaimerStore = useDisclaimerStore();
  disclaimerStore.clearDisclaimers();
});
